import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TConversation, TMessage } from 'types/inbox';
import InboxMessage from '../InboxMessage';
import s from './s.module.less';

type Props = {
    inboxMessageList?: TMessage[],
    inboxConversation?: TConversation,
};

const InboxMessageList = (props: Props) => {
    const { inboxMessageList, inboxConversation } = props;
    const navigate = useNavigate();
    // console.log({
    //     inboxMessageList,
    // })
    return (
        <div className={s.wrap}>
            {inboxMessageList?.map((item) => {
                return <InboxMessage inboxConversation={inboxConversation} inboxMessage={item} type="PROVIDER" />;
            })}
        </div>
    );
};

export default InboxMessageList;
